/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { DataSetDto } from './DataSetDto';
import {
    DataSetDtoFromJSON,
    DataSetDtoFromJSONTyped,
    DataSetDtoToJSON,
} from './DataSetDto';

/**
 * 
 * @export
 * @interface DataSetResponseDto
 */
export interface DataSetResponseDto {
    /**
     * 
     * @type {string}
     * @memberof DataSetResponseDto
     */
    startDate?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataSetResponseDto
     */
    endDate?: string | null;
    /**
     * 
     * @type {Array<DataSetDto>}
     * @memberof DataSetResponseDto
     */
    dataSets: Array<DataSetDto>;
    /**
     * 
     * @type {number}
     * @memberof DataSetResponseDto
     */
    totalDataSetCount: number;
    /**
     * 
     * @type {string}
     * @memberof DataSetResponseDto
     */
    $type?: DataSetResponseDtoTypeEnum;
}


/**
 * @export
 */
export const DataSetResponseDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedResultsDtoDataSetResponseDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Results.Dto.DataSetResponseDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type DataSetResponseDtoTypeEnum = typeof DataSetResponseDtoTypeEnum[keyof typeof DataSetResponseDtoTypeEnum];



/**
 * Check if a given object implements the DataSetResponseDto interface.
 */
export function instanceOfDataSetResponseDto(value?: unknown): value is DataSetResponseDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(DataSetResponseDtoTypeEnum)[0];
}

export function DataSetResponseDtoFromJSON(json: any): DataSetResponseDto {
    return DataSetResponseDtoFromJSONTyped(json, false);
}

export function DataSetResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DataSetResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'startDate': json['startDate'] == null ? undefined : json['startDate'],
        'endDate': json['endDate'] == null ? undefined : json['endDate'],
        'dataSets': ((json['dataSets'] as Array<any>).map(DataSetDtoFromJSON)),
        'totalDataSetCount': json['totalDataSetCount'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function DataSetResponseDtoToJSON(value?: DataSetResponseDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'startDate': value['startDate'],
        'endDate': value['endDate'],
        'dataSets': ((value['dataSets'] as Array<any>).map(DataSetDtoToJSON)),
        'totalDataSetCount': value['totalDataSetCount'],
        '$type': value['$type'],
    });
}

